export default {
    welcome: 'Welcome to our application!',
};
